import { computed, provide, ref, watch } from 'vue';

export type Position = {
    x: number;
    y: number;
};
export type LiveProjectile = {
    id: string;
    text: string;
    from?: Position;
    fromRect?: DOMRect;
    to?: Position;
    toRect?: DOMRect;
    class: string;
};

export const PROJECTILE_CONTROLLER_KEY = Symbol('projectileController');

type ProjectileSpawnedCallback = (projectile: LiveProjectile) => void;

// Provides a custom hook for managing projectiles state and logic
export function useProjectileProvider() {
    const projectiles = ref<LiveProjectile[]>([]);

    let onProjectileSpawn: ProjectileSpawnedCallback | null = null;

    watch(projectiles, (newProjectiles, oldProjectiles) => {
        if (!onProjectileSpawn || newProjectiles.length <= oldProjectiles.length) return;
        const newProjectile = newProjectiles[newProjectiles.length - 1];
        if (!newProjectile) return;
        onProjectileSpawn(newProjectile);
    });
    provide(PROJECTILE_CONTROLLER_KEY, {
        spawn(projectile: LiveProjectile) {
            if ((!projectile.from && !projectile.fromRect) || (!projectile.to && !projectile.toRect)) {
                throw new Error('Projectile must have both from and to positions or rects');
            }

            projectiles.value.push(projectile);
        },
        removeById(id: string) {
            projectiles.value = projectiles.value.filter((p) => p.id !== id);
        },
    });

    return {
        projectiles: computed(() => projectiles.value),
        spawned(cb: ProjectileSpawnedCallback) {
            onProjectileSpawn = cb;
        },
    };
}
